import { PARTICIPANT_INFO_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { ParticipantInfo } from "core/models/Bracket";

const intialState: {
  tournamentTeams: ParticipantInfo[];
  count: number;
  isLoading: boolean;
  currentPage :number,
} = {
  tournamentTeams: [],
  isLoading: false,
  count: 0,
  currentPage: 0
};

interface ActionType extends Action {
  payload: {
    tournamentTeams: ParticipantInfo[];
    count: number;
    // currentPage: number;
  };
}

export default function ParticipantInfoReducer(
  state = intialState,
  action: ActionType
) {
  switch (action.type) {
    case PARTICIPANT_INFO_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case PARTICIPANT_INFO_ACTION.SUCCESS:
      const { tournamentTeams, count } = action.payload;
      return { ...state, tournamentTeams, count, isLoading: false };

    case PARTICIPANT_INFO_ACTION.FAILURE:
      return { ...state, ...intialState };

    default:
      return state;
  }
}
